import React from 'react'
import { findDOMNode } from 'react-dom'
import { connect } from 'react-redux'
import ReactPlayer from 'react-player'
import { 
  getCurrentPlace,
} from '../selectors'
import { __, getLanguage } from '../lib/helpers'

import grau from '../assets/Avatar_Eco8_grau@2x.png'
import grauDisplay from '../assets/Avatar_Eco8_grau_display@2x.png'
import schwarz from '../assets/Avatar_Eco8_schwarz@2x.png'
import schwarzDisplay from '../assets/Avatar_Eco8_schwarz_display@2x.png'
import weiss from '../assets/Avatar_Eco8_weiss@2x.png'
import weissDisplay from '../assets/Avatar_Eco8_weiss_display@2x.png'

const propTypes = {
  mode: React.PropTypes.string.isRequired,
  setMode: React.PropTypes.func.isRequired,
  entityIsLoading: React.PropTypes.bool.isRequired,
  cameraIsFlying: React.PropTypes.bool.isRequired,
  selectedEntity: React.PropTypes.object,
}

class InfoBoxClass extends React.Component {

  constructor(props) {
    super(props)

    this.handleButtonClick = this.handleButtonClick.bind(this)
    this.handleVideo = this.handleVideo.bind(this)
  }
  
  handleButtonClick(event) {
    this.props.setShowForm(true)
  }
    
  handleVideo(event) {
    this.video.player.player.playVideo()
    this.video.player.player.pauseVideo()
    this.video.player.player.playVideo()
  }
    
  render() {
    let className
    if (this.props.entityIsLoading) {
      className = 'InfoBox InfoBox--loading InfoBox--'+this.props.entityType
      return (
        <div className={className}>
          <div className="sk-circle">
            <div className="sk-circle1 sk-child"></div>
            <div className="sk-circle2 sk-child"></div>
            <div className="sk-circle3 sk-child"></div>
            <div className="sk-circle4 sk-child"></div>
            <div className="sk-circle5 sk-child"></div>
            <div className="sk-circle6 sk-child"></div>
            <div className="sk-circle7 sk-child"></div>
            <div className="sk-circle8 sk-child"></div>
            <div className="sk-circle9 sk-child"></div>
            <div className="sk-circle10 sk-child"></div>
            <div className="sk-circle11 sk-child"></div>
            <div className="sk-circle12 sk-child"></div>
          </div>
        </div>
      )
    }

    if ( ! this.props.selectedEntity || this.props.cameraIsFlying) {
      className = 'InfoBox InfoBox--hidden InfoBox--'+this.props.entityType
      return (
        <div className={className}>
          
        </div>
      )
    }
    
    let { id, type, location, battery, video, ambassador, award } = this.props.selectedEntity

    // if no photo provided
    let imageSource
    if (battery && battery.photos && battery.photos.length > 0) {
      imageSource = battery.photos[0]
    } else if (ambassador && ambassador.photos && ambassador.photos.length > 0) {
      imageSource = ambassador.photos[0].url
    } else if (id) {
      switch (parseInt(id,36).toString().slice(-1)) {
        case "4" : // 20%
        case "5" :
          imageSource = weissDisplay
          break
        case "6" : // 10%
          imageSource = grau
          break
        case "7" : // 10%
          imageSource = grauDisplay
          break
        case "8" : // 10%
          imageSource = schwarz
          break
        case "9" : // 10%
          imageSource = schwarzDisplay
          break
        case "0" : // 40%
        case "1" :
        case "2" :
        case "3" :
        default :
          imageSource = weiss
          break
      }
    } else {
      imageSource = weiss
    }

    let i = <div className="InfoBox-imageContainer" style={{backgroundImage: 'url(' + imageSource + ')'}}></div>
    let title = __('InfoBox.sonnenBatterie')
    let displayName
    let statement
    let ambassadorSince
    let ambassadorSinceYear
    let monthNumber
    let monthName
    let capacity
    let autonomy7d
    let pvsize
    let cta = __('InfoBox.cta')
    let disclaimer
    switch (true) {

      case ambassador != null :
        title = ambassador.name
        if ( battery ) { displayName = <p>{battery.address}</p> }
        statement = <span><br /><em>{ambassador.statement}</em><br /></span>
        // ambassador.since date formatting
        if( ambassador.since ) {
          ambassadorSinceYear = ambassador.since.split('-')[0]
          monthNumber = ambassador.since.split('-')[1]
          switch(monthNumber){
            case '01':
              if( getLanguage().toUpperCase() == 'DE') { monthName = 'Januar' }
              else if( getLanguage().toUpperCase() == 'EN') { monthName = 'January' }
              break
            case '02':
              if( getLanguage().toUpperCase() == 'DE') { monthName = 'Februar' }
              else if( getLanguage().toUpperCase() == 'EN') { monthName = 'February' }
              break
            case '03':
              if( getLanguage().toUpperCase() == 'DE') { monthName = 'März' }
              else if( getLanguage().toUpperCase() == 'EN') { monthName = 'March' }
              break
            case '04':
              if( getLanguage().toUpperCase() == 'DE') { monthName = 'April' }
              else if( getLanguage().toUpperCase() == 'EN') { monthName = 'April' }
              break
            case '05':
              if( getLanguage().toUpperCase() == 'DE') { monthName = 'Mai' }
              else if( getLanguage().toUpperCase() == 'EN') { monthName = 'May' }
              break
            case '06':
              if( getLanguage().toUpperCase() == 'DE') { monthName = 'Juni' }
              else if( getLanguage().toUpperCase() == 'EN') { monthName = 'June' }
              break
            case '07':
              if( getLanguage().toUpperCase() == 'DE') { monthName = 'Juli' }
              else if( getLanguage().toUpperCase() == 'EN') { monthName = 'July' }
              break
            case '08':
              if( getLanguage().toUpperCase() == 'DE') { monthName = 'August' }
              else if( getLanguage().toUpperCase() == 'EN') { monthName = 'August' }
              break
            case '09':
              if( getLanguage().toUpperCase() == 'DE') { monthName = 'September' }
              else if( getLanguage().toUpperCase() == 'EN') { monthName = 'September' }
              break
            case '10':
              if( getLanguage().toUpperCase() == 'DE') { monthName = 'Oktober' }
              else if( getLanguage().toUpperCase() == 'EN') { monthName = 'October' }
              break
            case '11':
              if( getLanguage().toUpperCase() == 'DE') { monthName = 'November' }
              else if( getLanguage().toUpperCase() == 'EN') { monthName = 'November' }
              break
            case '12':
              if( getLanguage().toUpperCase() == 'DE') { monthName = 'Dezember' }
              else if( getLanguage().toUpperCase() == 'EN') { monthName = 'December' }
              break
          }
          ambassadorSince = <span><br /><strong>{__('InfoBox.ambassadorSince')}:</strong> {monthName} {ambassadorSinceYear}</span>
        }
        if ( battery ) { if (battery.capacity != 0 && battery.capacity != null) {  capacity = <span><br /><strong>{__('InfoBox.capacity')}:</strong> {battery.capacity} kWh</span> }}
        // autonomy7d = <span><br /><strong>{__('InfoBox.autonomy')}:</strong> {battery.autonomy7d} %</span>
        // pvsize = <span><br /><strong>{__('InfoBox.pvSize')}:</strong> {battery.pvsize} kWp</span>
        cta = __('InfoBox.ctaAmbassador')
        disclaimer = <span style={{display:'block',marginTop:'20px'}}>{__('InfoBox.disclaimer')}</span>
        break

      case award != null :
        statement = <span><br /><em>{award.statement}</em><br /></span>
        break

      case video != null :
        i = <ReactPlayer 
          url={video.url} 
          playing={false}
          volume={0.75}
          youtubeConfig={{ playerVars: { autoplay: 1, preload: true }}}
          className="Story-video"
          onReady={this.handleVideo}
          ref={(video) => {this.video = video}}
          playsinline
          controls
        />
        title = video.title
        break

      case battery != null :
        displayName = <p>{battery.address}</p>
        if (battery.capacity != 0 && battery.capacity != null) { capacity = <span><br /><strong>{__('InfoBox.capacity')}:</strong> {battery.capacity} kWh</span> }
        if (battery.autonomy7d != 0 && battery.autonomy7d != null) { autonomy7d = <span><br /><strong>{__('InfoBox.autonomy')}:</strong> {battery.autonomy7d} %</span> }
        if (battery.pvsize != 0 && battery.pvsize != null) { pvsize = <span><br /><strong>{__('InfoBox.pvSize')}:</strong> {battery.pvsize} kWp</span> }
        break
    }

    let infos
    if (id) {
      infos = (
        <div>
          {i}
          <div className="InfoBox-Innertext">
            <h3>{title}</h3>
            {displayName}
            <div className="InfoBox-Statement">
              {statement}
            </div>
            {ambassadorSince}
            {capacity}
            {autonomy7d}
            {pvsize}
            
          </div>
          <div className="InfoBox-Button">
            <a ref="btn" onClick={this.handleButtonClick}><div className="btn">{cta}</div></a>
          </div>
          <div className="InfoBox-Disclaimer">
            {disclaimer}
          </div>
        </div>
      )
    }

    className = (id) 
      ? 'InfoBox InfoBox--visible'
      : 'InfoBox InfoBox--hidden'

    return (
      <div className={className}>
        {infos}
      </div>
    )
  }

}


const mapStateToProps = (state, ownProps) => {
  return {
    
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

  }
}

InfoBoxClass.propTypes = propTypes

const InfoBox = connect(
  mapStateToProps,
  mapDispatchToProps
)(InfoBoxClass)

export default InfoBox



// WEBPACK FOOTER //
// ./src/components/InfoBox.js